import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from '@app/core/user/components/login/login.component';
import { FormTextComponent } from '@app/shared/components/form/components/form-text/form-text.component';

import { SharedModule } from '@app/shared/shared.module';
import { FacebookConnectModule } from '@app/core/user/components/facebook-connect/facebook-connect.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, FacebookConnectModule],
  declarations: [LoginComponent, FormTextComponent],
  exports: [LoginComponent],
  entryComponents: [LoginComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginModule {}
